export default from './MetaTags'


// WEBPACK FOOTER //
// ./src/components/MetaTags/index.js